const ITEMS = [
  "ISO 9001 CERTIFIED",
  "HOSPITAL-GRADE DISINFECTION",
  "24/7 EMERGENCY DISPATCH",
  "100% ECO-CONSCIOUS FORMULAS",
  "FULLY BONDED & INSURED STAFF",
  "WEST MIDLANDS COVERAGE",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-white/10 bg-navy-950 py-5 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center shrink-0">
              <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-ice-200/60 px-8">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-gold-500 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
